import { Controller, FieldValues, RegisterOptions } from "react-hook-form";
import ReactDatePicker from "react-datepicker"; // Import the datepicker
import "react-datepicker/dist/react-datepicker.css";

interface Props {
  label?: string;
  inputClassName?: string;
  labelClassName?: string;
  placeholder?: string;
  error?: boolean;
  control?: any;
  name?: string;
  disabled?: boolean;
  rules?:
  | Omit<
    RegisterOptions<FieldValues, string>,
    "valueAsNumber" | "valueAsDate" | "setValueAs" | "disabled"
  >
  | undefined;
}

export const ControlledDateTimePicker = ({
  label,
  inputClassName,
  labelClassName,
  placeholder,
  error,
  control,
  name,
  rules,
  disabled,
  ...rest
}: Props) => {
  /** Callbacks */
  const getMinTime = (date: Date) => {
    const today = new Date();
    const isToday = date.toDateString() === today.toDateString();

    if (isToday) {
      return new Date(); // Return current time if the selected date is today
    }
    return new Date(date.setHours(0, 0, 0, 0)); // Return start of day for future dates
  };
  return (
    <div className="mb-4">
      <p
        className={`font-satoshi text-dark text-sm font-medium mb-3 ${labelClassName}`}
      >
        {label}
      </p>
      <Controller
        control={control}
        name={name as string}
        rules={rules}
        render={({ field: { onChange, value } }) => (
          <ReactDatePicker
            {...rest}
            disabled={disabled}
            selected={value}
            onChange={onChange}
            showTimeSelect // Enables time selection
            dateFormat="Pp" // Formats the date and time display
            minDate={new Date()}
            minTime={getMinTime(new Date(value ?? new Date()) ?? new Date())}
            // @ts-ignore
            maxTime={new Date().setHours(23, 59, 59)}
            className={`w-full h-[46px] px-4 bg-sky-lighter border ${error ? "border-red-base" : "border-gray-border"
              } ${error ? "focus:border-red-base" : "focus:border-focused-border"
              } rounded font-satoshi text-base text-dark font-medium outline-none ${inputClassName}`}
            placeholderText={placeholder}
            wrapperClassName="w-full"
          />
        )}
      />
    </div>
  );
};

// New FlexibleDateTimePicker component
interface FlexibleDateTimePickerProps extends Props {
  minDate?: Date;
  minTime?: Date;
}

export const FlexibleDateTimePicker = ({
  label,
  inputClassName,
  labelClassName,
  placeholder,
  error,
  control,
  name,
  rules,
  disabled,
  minDate = new Date('2024-01-01'),
  minTime = new Date('2024-01-01'),
  ...rest
}: FlexibleDateTimePickerProps) => {
  return (
    <div className="mb-4">
      <p
        className={`font-satoshi text-dark text-sm font-medium mb-3 ${labelClassName}`}
      >
        {label}
      </p>
      <Controller
        control={control}
        name={name as string}
        rules={rules}
        render={({ field: { onChange, value } }) => (
          <ReactDatePicker
            {...rest}
            disabled={disabled}
            selected={value}
            onChange={onChange}
            showTimeSelect
            dateFormat="Pp"
            minDate={minDate}
            minTime={minTime}
            // @ts-ignore
            maxTime={new Date().setHours(23, 59, 59)}
            className={`w-full h-[46px] px-4 bg-sky-lighter border ${error ? "border-red-base" : "border-gray-border"}
              ${error ? "focus:border-red-base" : "focus:border-focused-border"}
              rounded font-satoshi text-base text-dark font-medium outline-none ${inputClassName}`}
            placeholderText={placeholder}
            wrapperClassName="w-full"
          />
        )}
      />
    </div>
  );
};
